import React from 'react';
import { default as Form } from '../components/connectedForm';
import ExpandedRowRenderer from '../components/EditableDataGrid/ExpandedRowRenderer';
import styled from 'styled-components';
import BlurTextField from '../components/connectedForm/BlurTextField/BlurTextField';
import Label from '../components/connectedForm/Label';
import moment from 'moment';

import { formatValue } from '../components/grid-addons/formatters/FormatValue';
import { ISalesTransaction } from '../graphql/schema/p4types';

const LineBreak = styled.div`
  padding-top: 10px;
  border-top: 2px solid darkgray;
`;

const ExpansionContainer = styled.div`
  padding-left: 10px;
  padding-top: 8px;
  width: 90%;
`;

//TODO - make fields a prop and refactor into a generic expansion formatter

const fields = [
  { value: 'uuid' },
  { value: 'documentType', label: 'Type' },
  { value: 'documentNumber', label: 'Invoice / Opening Balance' },
  { value: 'documentReference', label: 'Reference' },
  { value: 'baseAmount', label: 'Amount', formatter: sterlingFormatter },
  { value: 'baseOutstandingAmount', label: 'Outstanding', formatter: sterlingFormatter },
  {
    value: 'paymentDueDate',
    label: 'Payment Due',
    formatter: dateFormatter,
  },
];

function dateFormatter(value: string) {
  return moment(value).format('DD MMM YY');
}

function numericFormatter(value: string) {
  return formatValue(value, { dependentValues: {}, decimals: 2 });
}

function sterlingFormatter(value: string) {
  return `£${formatValue(value, { dependentValues: {}, decimals: 2 })}`;
}

const cols = 1 / fields.filter(({ label }) => label).length;

const SalesTransactionDetail = (props: any) => {
  const renderFields = () => {
    return fields
      .filter(({ label }) => label)
      .map(({ value, label, formatter }) => {
        if (label) {
          const formattedValue = formatter ? formatter(props.transaction[value]) : props.transaction[value];
          return (
            <Form.Fieldset cols={cols}>
              <BlurTextField includeLabel={false} value={formattedValue} readOnly={true} data-testid={label} />
            </Form.Fieldset>
          );
        }
      });
  };

  return <Form.Row key={props.uuid}>{renderFields()}</Form.Row>;
};

const SalesTransactionHeading = () => {
  const renderHeadings = () => {
    return fields
      .filter(({ label }) => label)
      .map(({ label }) => {
        if (label) {
          return (
            <Form.Fieldset cols={cols}>
              <Label bold={true}>{label}</Label>
            </Form.Fieldset>
          );
        }
      });
  };

  return <Form.Row>{renderHeadings()}</Form.Row>;
};

const SalesTransactions = (props: { row: { salesTransactions?: Array<ISalesTransaction> } }) => {
  const transactions: Array<any> = props.row?.salesTransactions ?? [];

  const transactionList = transactions.map((transaction: any, index) => {
    return <SalesTransactionDetail key={transaction.uuid ?? transaction.id} transaction={transaction} />;
  });

  return (
    <LineBreak>
      <ExpansionContainer>
        <SalesTransactionHeading />
        {transactionList}
      </ExpansionContainer>
    </LineBreak>
  );
};

export const SalesTransactionExpansion = (props: any) => {
  return <ExpandedRowRenderer {...props} expansion={SalesTransactions} />;
};
